module.exports = __webpack_public_path__ + "assets/74a19b3396f53f9b7dadbadcbb87a297.mp3";